<template>
  <textarea v-bind="$attrs" ref="text" v-model="currentValue" @input="update"></textarea>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      currentValue: this.getDefaultValue(),
    }
  },
  watch: {
    modelValue(value) {
      if (this.currentValue !== value) {
        this.currentValue = value
      }
    },
  },
  methods: {
    getDefaultValue() {
      if (this.modelValue) {
        return this.modelValue
      }
      if (this.$slots.default && this.$slots.default().length) {
        return this.$slots.default()[0].text
      }
      return ''
    },
    update() {
      this.$emit('update:modelValue', this.currentValue)
      this.$refs.text.style.height = '5px'
      this.$refs.text.style.height = `${Math.max(this.$refs.text.scrollHeight, 50)}px`
    },
  },
}
</script>

<style scoped lang="scss">
textarea {
  min-height: 50px;
  max-height: 500px;
}
</style>
